import styled from 'styled-components';
import {
  floatingComponentStyles,
  overflowingStyles,
} from '../../../styles/shareableStyles';
import { theme } from '../../../styles/theme';

export const Container = styled.div`
  min-width: 300px;
  max-width: 350px;
  ${floatingComponentStyles};
  color: ${theme.colors.secondary800};
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  column-gap: 4px;
  padding: 6px 12px;
  border-bottom: 1px solid ${theme.colors.border};
`;

export const DateWrapper = styled.div`
  flex: 1;
  max-width: 100%;
  font-size: 12px;
  ${overflowingStyles};
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 6px;
  padding: 12px;
`;

export const Title = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: ${theme.colors.secondary900};
`;

export const Description = styled.div`
  font-size: 12px;
  word-break: break-word;
`;

export const Footer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
